// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/hinted-GorditaRegular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/hinted-GorditaMedium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/hinted-GorditaBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fonts */
@font-face {
    font-family: "Gordita";
    font-display: swap;
    font-style: normal;
    font-weight: 100;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
    font-family: "Gordita";
    font-display: swap;
    font-style: normal;
    font-weight: 200;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  }
  @font-face {
    font-family: "Gordita";
    font-display: swap;
    font-style: normal;
    font-weight: 300;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  }
  @font-face {
    font-family: "Gordita";
    font-display: swap;
    font-style: normal;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  }
  @font-face {
    font-family: "Gordita";
    font-display: swap;
    font-weight: 500;
    font-style: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  }
  @font-face {
    font-family: "Gordita";
    font-display: 600;
    font-style: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  }
  @font-face {
    font-family: "Gordita";
    font-display: swap;
    font-weight: bold;
    font-style: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  }
  @font-face {
    font-family: "Gordita";
    font-display: swap;
    font-style: normal;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  }
  @font-face {
    font-family: "Gordita";
    font-display: swap;
    font-style: normal;
    font-weight: 800;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  }
  @font-face {
    font-family: "Gordita";
    font-display: swap;
    font-style: normal;
    font-weight: 900;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  }
  @font-face {
    font-family: "Gordita";
    font-display: swap;
    font-style: normal;
    font-weight: bolder;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  }
  `, "",{"version":3,"sources":["webpack://./src/v3/assets/css/GorditaFonts.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,+DAA+D;AACnE;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,+DAA+D;EACjE;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,+DAA+D;EACjE;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,+DAA+D;EACjE;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,+DAA8D;EAChE;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,+DAA8D;EAChE;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,+DAA8D;EAChE;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,+DAA4D;EAC9D;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,+DAA4D;EAC9D;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,+DAA4D;EAC9D;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,+DAA4D;EAC9D","sourcesContent":["/* Fonts */\n@font-face {\n    font-family: \"Gordita\";\n    font-display: swap;\n    font-style: normal;\n    font-weight: 100;\n    src: url(../fonts/hinted-GorditaRegular.ttf) format(\"truetype\");\n}\n@font-face {\n    font-family: \"Gordita\";\n    font-display: swap;\n    font-style: normal;\n    font-weight: 200;\n    src: url(../fonts/hinted-GorditaRegular.ttf) format(\"truetype\");\n  }\n  @font-face {\n    font-family: \"Gordita\";\n    font-display: swap;\n    font-style: normal;\n    font-weight: 300;\n    src: url(../fonts/hinted-GorditaRegular.ttf) format(\"truetype\");\n  }\n  @font-face {\n    font-family: \"Gordita\";\n    font-display: swap;\n    font-style: normal;\n    font-weight: 400;\n    src: url(../fonts/hinted-GorditaRegular.ttf) format(\"truetype\");\n  }\n  @font-face {\n    font-family: \"Gordita\";\n    font-display: swap;\n    font-weight: 500;\n    font-style: normal;\n    src: url(../fonts/hinted-GorditaMedium.ttf) format(\"truetype\");\n  }\n  @font-face {\n    font-family: \"Gordita\";\n    font-display: 600;\n    font-style: normal;\n    src: url(../fonts/hinted-GorditaMedium.ttf) format(\"truetype\");\n  }\n  @font-face {\n    font-family: \"Gordita\";\n    font-display: swap;\n    font-weight: bold;\n    font-style: normal;\n    src: url(../fonts/hinted-GorditaMedium.ttf) format(\"truetype\");\n  }\n  @font-face {\n    font-family: \"Gordita\";\n    font-display: swap;\n    font-style: normal;\n    font-weight: 700;\n    src: url(../fonts/hinted-GorditaBold.ttf) format(\"truetype\");\n  }\n  @font-face {\n    font-family: \"Gordita\";\n    font-display: swap;\n    font-style: normal;\n    font-weight: 800;\n    src: url(../fonts/hinted-GorditaBold.ttf) format(\"truetype\");\n  }\n  @font-face {\n    font-family: \"Gordita\";\n    font-display: swap;\n    font-style: normal;\n    font-weight: 900;\n    src: url(../fonts/hinted-GorditaBold.ttf) format(\"truetype\");\n  }\n  @font-face {\n    font-family: \"Gordita\";\n    font-display: swap;\n    font-style: normal;\n    font-weight: bolder;\n    src: url(../fonts/hinted-GorditaBold.ttf) format(\"truetype\");\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
